module.exports = __webpack_public_path__ + "static/media/Loading.f799e5f0.gif";